import type { FilterDict, FacetDef } from '../../list-controls/types';
import type { FilterState } from './types';
import type { KindConfig } from './kindConfig';

/** Lightweight facet-source option (was previously exported by the deleted AttachToolbar). */
export interface FacetSourceOption { value: string; label: string }

export function filtersToDict(f: FilterState): FilterDict {
  return { lifecycle: f.lifecycles, type: f.typeIds, owner: f.ownerIds };
}
export function dictToFilters(dict: FilterDict, prev: FilterState): FilterState {
  return { ...prev, lifecycles: dict.lifecycle ?? [], typeIds: dict.type ?? [], ownerIds: dict.owner ?? [] };
}
export function buildFacetDefs(config: KindConfig, typeFacet: FacetSourceOption[], ownerFacet: FacetSourceOption[]): FacetDef[] {
  const defs: FacetDef[] = [];
  if (config.lifecycleOptions.length > 0)
    defs.push({ key: 'lifecycle', label: 'Lifecycle', options: config.lifecycleOptions.map((o) => ({ id: o.value, label: o.label })) });
  if (config.hasTypeFacet && typeFacet.length > 0)
    defs.push({ key: 'type', label: 'Type', options: typeFacet.map((o) => ({ id: o.value, label: o.label })) });
  if (config.hasOwnerFacet && ownerFacet.length > 0)
    defs.push({ key: 'owner', label: 'Owner', options: ownerFacet.map((o) => ({ id: o.value, label: o.label })) });
  return defs;
}
